import { isBefore, subMinutes } from 'date-fns';

import { LoginSuccess } from 'entities';

import { store } from 'config/storage';
import { env } from 'config/env';
import { AnyObject } from 'types';

export function shouldRefreshSession(data: LoginSuccess | null) {
  if (!data) return false;

  const { accessValidity, refreshValidity } = data;

  const today = new Date();

  // Safety net
  const accessLimit = subMinutes(new Date(accessValidity), 30);

  const refreshLimit = new Date(refreshValidity);

  const accessExpired = isBefore(accessLimit, today);
  const refreshExpired = isBefore(refreshLimit, today);

  return accessExpired && !refreshExpired;
}

function validateSession({ accessValidity, refreshValidity }: LoginSuccess): boolean {
  try {
    if (!accessValidity || !refreshValidity) return false;

    const today = new Date();
    const accessLimit = new Date(refreshValidity);

    const accessExpired = isBefore(accessLimit, today);

    return !accessExpired;
  } catch (err) {
    return false;
  }
}

export function getSavedUserInfo(): LoginSuccess | null {
  const user = store.user.get();

  if (!user) return null;

  const validSession = validateSession(user);

  if (validSession) return user;

  store.user.delete();

  return null;
}

type LoginNavigationProps = AnyObject & {
  emailPasswordReset?: string;
};

export function navigateToLogin({ emailPasswordReset }: LoginNavigationProps = {}) {
  const url = new URL(env.authUrl);

  if (emailPasswordReset) {
    url.searchParams.set('email', emailPasswordReset);
    url.searchParams.set('reset-pw', 'success');
    url.searchParams.set('timestamp', new Date().toISOString());
  }

  location.href = url.toString();
}
